
import { Spinner } from 'sr/helpers';
interface Props {
  loader?: boolean,
  children: React.ReactNode
  height:string
}

const ContentWithSpinner = ({loader, children, height='' }: Props) => {
  return loader ? (
    <div className={`relative w-full ${height ? height : ''}`}>
      <div className="absolute inset-0 flex items-center justify-center">
        <Spinner size={`w-10 h-10`} />
      </div>
    </div>
) : (
  <>{children}</>
);
};
export default ContentWithSpinner;
ContentWithSpinner.defaultProps = {
  height:''
}